import Joblist from "../components/Joblist/Joblist";

const JoblistPage = () => {
  return <Joblist />;
};

export default JoblistPage;
